import { Checkbox, ModalDialog, type ModalDialogRef } from '@myosh/odin-components';
import { forwardRef, type Ref, useState } from 'react';

interface AiAnalysisConfirmationModalProps {
  handleSubmitConfirmation: (value: boolean) => void;
  handleCloseModal: () => void;
}

const AiAnalysisConfirmationModal = (
  { handleSubmitConfirmation, handleCloseModal }: AiAnalysisConfirmationModalProps,
  forwardRef: Ref<ModalDialogRef>
) => {
  const [isAiAnalysisConfirmationCheckboxChecked, setIsAiAnalysisConfirmationCheckboxChecked] = useState(false);

  return (
    <ModalDialog
      data-cy="ai-analysis-confirmation-modal"
      buttons={[
        {
          name: 'submit',
          text: 'Ok',
          type: 'primary',
          onClick: () => handleSubmitConfirmation(isAiAnalysisConfirmationCheckboxChecked),
        },
        {
          name: 'cancel',
          text: 'Cancel',
          type: 'default',
          variant: 'alternative',
          onClick: handleCloseModal,
        },
      ]}
      header={''}
      shouldCheckZIndex={true}
      ref={forwardRef}
    >
      <div className="flex flex-col gap-4">
        <p className="text-lg font-semibold">
          Warning: Data is sent to an external AI. Verify all AI results for accuracy.
        </p>
        <Checkbox
          data-cy="ai-analysis-confirmation-checkbox"
          name="show-ai-analysis-confirmation"
          label="Don’t show me again"
          initialChecked={false}
          onChange={(value) => setIsAiAnalysisConfirmationCheckboxChecked(value!.checked)}
        />
      </div>
    </ModalDialog>
  );
};

export default forwardRef(AiAnalysisConfirmationModal);
